"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.H5Markdown = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

var _Markdown = _interopRequireDefault(require("./Markdown"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propDoc = {};
var demoProps = {};
var demoRender = "\n<H5>\n  This is an H5\n</H5>\n";

var H5 = function H5(props) {
  var children = props.children,
      className = props.className,
      style = props.style;
  var styles = useStylesheet();

  var _useTheming = (0, _providers.useTheming)(),
      textBlack = _useTheming.theme.textBlack;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.root, styles.bold, className),
    style: _objectSpread(_objectSpread({}, style), {}, {
      fontSize: 20,
      color: textBlack
    })
  }, children);
};

var H5Markdown = function H5Markdown(props) {
  var className = props.className,
      style = props.style,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["className", "style"]);
  var styles = useStylesheet();

  var _useTheming2 = (0, _providers.useTheming)(),
      textBlack = _useTheming2.theme.textBlack;

  return /*#__PURE__*/_react["default"].createElement(_Markdown["default"], (0, _extends2["default"])({
    className: (0, _styling.css)(styles.root, className),
    style: _objectSpread(_objectSpread({}, style), {}, {
      fontSize: 20,
      color: textBlack
    })
  }, otherProps));
};

exports.H5Markdown = H5Markdown;
H5.propDoc = propDoc;
H5.demoProps = demoProps;
H5.demoRender = demoRender;
var _default = H5;
exports["default"] = _default;

var useStylesheet = function useStylesheet() {
  var _useTheming3 = (0, _providers.useTheming)(),
      fonts = _useTheming3.fonts;

  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.4,
        letterSpacing: "normal"
      },
      bold: {
        fontFamily: fonts.bold
      }
    });
  }, [fonts.bold]);
};